import { render, staticRenderFns } from "./image-editor.vue?vue&type=template&id=affc66e0&scoped=true&"
import script from "./image-editor.vue?vue&type=script&lang=js&"
export * from "./image-editor.vue?vue&type=script&lang=js&"
import style0 from "./image-editor.vue?vue&type=style&index=0&id=affc66e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affc66e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
